import { Text } from '@chakra-ui/react';
import React from 'react';

export const FooterHeading = ({ children }: { children: React.ReactNode }) => {
	return (
		<Text
			color="#6D6D6D"
			mb="19px"
			textTransform="uppercase"
			fontWeight="600"
			fontSize="12px"
			letterSpacing="0.08em"
		>
			{children}
		</Text>
	);
};
